import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ChevronRight, Dumbbell, HeartPulse, Sparkles } from 'lucide-react'
import { Card, CardContent } from '../../../components/ui/card'

const TYPE_ICON = {
  day1_chest_back: Dumbbell,
  day2_arms_shoulders: Dumbbell,
  day3_legs: Dumbbell,
  cardio_only: HeartPulse,
  custom: Sparkles,
}

function formatDate(iso, lang) {
  if (!iso) return ''
  try {
    return new Date(iso + 'T00:00:00').toLocaleDateString(lang || 'en', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    })
  } catch {
    return iso
  }
}

export default function SessionCard({ session }) {
  const { t, i18n } = useTranslation()
  const Icon = TYPE_ICON[session.session_type] || Dumbbell
  const date = formatDate(session.date, i18n.language)
  const typeLabel = t(`workout.sessionType.${session.session_type}`, { defaultValue: session.session_type })

  const showStrength = session.exerciseCount > 0
  const showCardio = session.cardioCount > 0

  return (
    <Link to={`/workout/sessions/${session.id}`} className="block">
      <Card className="hover:border-app-primary-500/40 hover:shadow-sm transition-all">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-center gap-3">
            <div className="rounded-full bg-app-primary-100 dark:bg-app-primary-900/30 p-2 flex-shrink-0">
              <Icon className="w-4 h-4 text-app-primary-500" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-baseline justify-between gap-2">
                <p className="text-sm font-medium text-foreground truncate">{typeLabel}</p>
                <p className="text-xs text-muted-foreground flex-shrink-0">{date}</p>
              </div>
              <div className="flex flex-wrap gap-x-2 gap-y-0.5 text-xs text-muted-foreground mt-0.5">
                {showStrength && (
                  <span>
                    {t('workout.history.summary', {
                      exercises: session.exerciseCount,
                      sets: session.setCount,
                      volume: Math.round(session.totalVolume).toLocaleString(),
                    })}
                  </span>
                )}
                {showCardio && (
                  <span>{t('workout.history.summaryCardio', { cardio: session.cardioDurationMin })}</span>
                )}
                {session.duration_min && (
                  <span>{t('workout.history.duration', { min: session.duration_min })}</span>
                )}
                {session.body_weight_kg && (
                  <span>{t('workout.history.bodyWeight', { kg: session.body_weight_kg })}</span>
                )}
              </div>
            </div>
            <ChevronRight className="w-4 h-4 text-muted-foreground rtl:-scale-x-100 flex-shrink-0" />
          </div>
        </CardContent>
      </Card>
    </Link>
  )
}
